__turbopack_context__.v({
  "discountSignal": "DiscountSignal-module-scss-module__fL_eba__discountSignal",
});
